import { filter, find, map } from 'underscore';
import { useMediaQuery } from 'react-responsive';
import { breakPoints } from 'app/constants';
import classNames from 'classnames';
import { Row } from 'antd';
import { Category, CategoryLoader } from 'app/components/content/category';
import { Slider } from 'app/modules/lending/components/slider';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useGetLandingTypesQuery } from 'app/api';

export const LendingTypes = memo(
    ({
        data: types,
        allowEdit,
        onEdit,
        onDelete,
        onAddImage,
        uuid,
        point,
        setInitialData,
        isAdmin,
        isAdded,
    }) => {
        const [active, setActive] = useState(0);
        const refs = useRef([]);

        const { data, isFetching } = useGetLandingTypesQuery(
            {
                id: uuid,
                point,
            },
            { skip: !isAdded }
        );

        const responseTypes = data?.data_response?.types;
        useEffect(() => {
            if (data?.success) {
                setInitialData(uuid, responseTypes);
            }
        }, [data]);

        useEffect(() => {
            if (!refs.current) return;
            const observer = new IntersectionObserver((entries) => {
                const entry = find(entries, (entry) => entry?.isIntersecting);
                if (entry) setActive(entry?.target?.id);
            });
            refs.current.map((e) => e && observer.observe(e));
            return () => {
                observer.disconnect();
            };
        }, [refs.current]);

        useEffect(() => {
            refs.current = filter(refs.current, (ref) =>
                find(types, (type) => type?.id == ref?.id)
            );
        }, [types]);

        const isMobile = !useMediaQuery({
            query: breakPoints.mobile,
        });
        if (data?.success === false) return null;
        return (
            <>
                <div
                    className={classNames(
                        'lending-categories',
                        'lending-categories-types'
                    )}
                >
                    <Row
                        style={{
                            width: '100%',
                            marginLeft: 0,
                            marginRight: 0,
                            gap: '15px',
                        }}
                        wrap={!isMobile}
                        gutter={isMobile ? [15, 15] : [30, 30]}
                    >
                        {isFetching
                            ? Array.from({ length: 8 }).map((_, index) => (
                                  <div
                                      className={
                                          isMobile && 'lending-category-wrapper'
                                      }
                                      key={index}
                                      style={{ minWidth: '200px', flex: 1 }}
                                  >
                                      <CategoryLoader />
                                  </div>
                              ))
                            : map(types, ({ id, img, name }, index) => (
                                  <div
                                      className={
                                          isMobile && 'lending-category-wrapper'
                                      }
                                      key={id}
                                      style={{ minWidth: '200px', flex: 1 }}
                                  >
                                      <Category
                                          tooltip
                                          className={'lending-category'}
                                          allowEdit={allowEdit}
                                          ref={(el) =>
                                              (refs.current[index] = el)
                                          }
                                          img={img}
                                          id={id}
                                          title={name}
                                          onAddImage={() => onAddImage(id)}
                                          onEdit={() => onEdit(id, img)}
                                          onDelete={() => onDelete(id)}
                                      />
                                  </div>
                              ))}
                    </Row>
                </div>
                {isMobile ? (
                    <Slider
                        collection={types}
                        active={(item) => item.id == active}
                        className={'mt-3'}
                    />
                ) : null}
            </>
        );
    }
);
